var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-col",
    { staticClass: "cardinfo", attrs: { xs: 24, sm: 12, md: 6, lg: 6 } },
    [
      _c(
        "el-card",
        {
          staticClass: "property",
          attrs: { shadow: "always", role: "button", tabindex: "-1" }
        },
        [
          _c("el-row", { staticClass: "card-row", attrs: { gutter: 40 } }, [
            _c("div", { staticClass: "icon-col" }, [
              _c("div", { class: ["icon", _vm.info.icon.color] }, [
                _c("i", { class: _vm.info.icon.class })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card-col" }, [
              _c("div", { staticClass: "information" }, [
                _c(
                  "div",
                  { staticClass: "value" },
                  [
                    _c("count-to", {
                      staticClass: "card-panel-num",
                      attrs: {
                        "start-val": 0,
                        "end-val": _vm.info.count.endVal,
                        duration: 2600,
                        decimals: _vm.info.count.decimal
                          ? _vm.info.count.numberOfDecimal
                          : 0
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "unit" }, [
                      _vm._v(_vm._s(_vm.info.count.unit))
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "label" }, [
                  _vm._v(
                    "\n            " + _vm._s(_vm.info.text) + "\n          "
                  )
                ])
              ])
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }